import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tc-initials absolute top-0 right-0 w-8 h-5 rounded-none rounded-tr-md" }
const _hoisted_2 = { class: "comment-icon" }
const _hoisted_3 = { class: "text-body-2" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_5 = {
  key: 1,
  class: "flex justify-center"
}
const _hoisted_6 = {
  key: 2,
  class: "text-body-2 treatment-time"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_TreatmentDialog = _resolveComponent("TreatmentDialog")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: _normalizeClass(["treatment-card", [ _ctx.bgColor, {'unSelectedByDoctor': _ctx.isDisabled && !!_ctx.filter} ]]),
    disabled: _ctx.disabled,
    onMousedown: _ctx.start,
    onMouseleave: _ctx.stop,
    onMouseup: _ctx.stop,
    onTouchcancel: _ctx.stop,
    onTouchend: _ctx.stop,
    onTouchstart: _ctx.start
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.treatment.has_notes)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                color: "blue-darken-2",
                size: 18
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-message-text", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "text-xs font-bold text-center",
          style: _normalizeStyle({
          backgroundColor: _ctx.initialsBackgroundColor,
          color: _ctx.$filters.foregroundColor(_ctx.initialsBackgroundColor)
        })
        }, _toDisplayString(_ctx.initials), 5)
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.isCompleted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_v_btn, {
              density: "compact",
              variant: "text",
              icon: "mdi-checkbox-marked-circle-outline",
              color: `#01492b`
            })
          ]))
        : (!_ctx.startedAt || _ctx.isPaused)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.interactWithBoard)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    id: "btn-1",
                    density: "compact",
                    color: "gray-darken-2",
                    variant: "text",
                    icon: _ctx.isPaused ? 'mdi-motion-play-outline' : 'mdi-play',
                    disabled: _ctx.isDisabled,
                    onClick: _withModifiers(_ctx.handlePlay, ["stop"]),
                    onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                    onMouseup: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                    onTouchstart: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                    onTouchend: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8, ["icon", "disabled", "onClick"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.timeElapsedFormatted) + _toDisplayString(_ctx.timeElapsed >= 3600000 ? 'm' : 's') + " | " + _toDisplayString(_ctx.timeAllocatedFormatted) + _toDisplayString(_ctx.timeAllocated >= 3600000 ? 'm' : 's'), 1)),
      (_ctx.openedTreatment === _ctx.treatment.uuid)
        ? (_openBlock(), _createBlock(_component_TreatmentDialog, {
            key: 3,
            appointment: _ctx.appointment,
            "appointment-id": _ctx.appointment.uuid,
            name: _ctx.treatment.treatment.full_name,
            administrator: _ctx.treatment.doctor.uuid,
            notes: _ctx.treatmentNotes,
            "room-name": _ctx.room.name,
            time: _ctx.timeElapsed,
            "allocated-time": _ctx.timeAllocated,
            treatment: _ctx.treatment,
            "card-state": _ctx.treatmentState,
            "is-disabled": _ctx.isDisabled,
            onClose: _ctx.closeDialog,
            onPlay: _ctx.handlePlay,
            onPause: _ctx.handlePause,
            onCompleteTreatment: _ctx.handleCompleteTreatment,
            onResetTreatment: _ctx.handleResetTreatment,
            onUpdateAllocatedTime: _ctx.handleUpdatetimeAllocated
          }, null, 8, ["appointment", "appointment-id", "name", "administrator", "notes", "room-name", "time", "allocated-time", "treatment", "card-state", "is-disabled", "onClose", "onPlay", "onPause", "onCompleteTreatment", "onResetTreatment", "onUpdateAllocatedTime"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "disabled", "onMousedown", "onMouseleave", "onMouseup", "onTouchcancel", "onTouchend", "onTouchstart"]))
}